import { ErrorComponent, type ErrorComponentProps } from '@tanstack/react-router';
import { useEffect } from 'react';
import { isChunkLoadError, reloadForStaleChunk } from '@/lib/lazy-with-reload';
import { reportRouteError } from '@/lib/api-diagnostics';

/**
 * Router-wide error boundary fallback. Keeps TanStack Router's default
 * presentation but also forwards the error to telemetry — render errors caught
 * here never hit `window.onerror`, so this is the only place they get reported.
 */
export function RouteErrorComponent(props: ErrorComponentProps) {
  const reloading = isChunkLoadError(props.error) && reloadForStaleChunk();

  useEffect(() => {
    if (reloading) return;
    reportRouteError(props.error);
  }, [props.error, reloading]);

  if (reloading) {
    return (
      <div className="flex items-center justify-center py-12 text-muted-foreground">
        Updating to the latest version…
      </div>
    );
  }

  return <ErrorComponent error={props.error} />;
}
